import { HttpRequest } from './http-request';
import { HttpMediaType } from './http-media-types';

export class HttpRequestBuilder {
  constructor(public readonly contextPath: string) {}

  /**
   * Create an authenticated request with json accept type
   * @param path partial path or null
   */
  public json(path: string): HttpRequest {
    return this.api(path).acceptType(HttpMediaType.ApplicationJson);
  }

  /**
   * Create authenticated request
   * @param path partial path
   */
  public api(path?: string): HttpRequest {
    return new HttpRequest(this.contextPath).path(path!).authenticated();
  }

  /**
   * Create public request (not authenticated) with context path.
   * @param path partial path
   */
  public public(path: string): HttpRequest {
    return new HttpRequest(this.contextPath).path(path);
  }
}
